import { map } from 'rxjs/operators';
import { PermissionCategory } from '../../shared/models/permission-category.model';
import { MappedCollectionResponse } from '../models/mapped-collection-response.model';
import { ResponseNode } from '../models/response-node.model';

export const createPermissionCategoryObjects = map((response: MappedCollectionResponse): Array<PermissionCategory> => (
  response.data.map((element: ResponseNode): PermissionCategory => new PermissionCategory().deserialize(element, response.includedMap))
));
